import { useMemo } from 'react'
import { Box, Card, CardContent,Typography } from '@mui/material'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js'
import { Line } from 'react-chartjs-2'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
)

const colors = {
  light: '#dcff90',
  main: '#cdff65',
  dark: '#9dd328',
  contrastText: '#121212',
}

function formatTimestamp(ts) {
  const date = new Date(ts)
  if (Number.isNaN(date.getTime())) return String(ts)

  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

export default function MetricChart({
  timestamps = [],
  vals = [],
  title = "",
}) {
  const { labels, values } = useMemo(() => {
    const len = Math.min(timestamps.length, vals.length)

    if (timestamps.length > 0 && vals.length > 0) {
      return {
        labels: timestamps.slice(0, len).map(formatTimestamp),
        values: vals.slice(0, len),
      }
    } else {
      return {
        labels: [],
        values: [],
      } 
    }
    
  }, [timestamps, vals])

  const data = {
    labels,
    datasets: [
      {
        data: values,
        borderColor: colors.dark,
        backgroundColor: 'rgba(205, 255, 101, 0.18)',
        pointBackgroundColor: colors.main,
        pointBorderColor: colors.dark,
        pointRadius: 3,
        pointHoverRadius: 5,
        borderWidth: 2,
        tension: 0.35,
        fill: true,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: colors.contrastText,
        titleColor: colors.light,
        bodyColor: colors.light,
        displayColors: false,
        callbacks: {
          title: (items) => items?.[0]?.label || '',
          label: (context) => `Force: ${context.parsed.y}`,
        },
      },
    },
    scales: {
      x: {
        display: false,
        grid: { display: false },
        border: { display: false },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: '#fff',
        },
        grid: {
          color: 'rgba(18, 18, 18, 0.08)',
        },
        border: {
          display: false,
        },
      },
    },
  }

  if (!timestamps.length || !vals.length) {
    // console.log(timestamps.length, "LL", vals.length)
    return (
      <></>
    )
  }

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 3,
        borderColor: 'rgba(18, 18, 18, 0.12)',
        backgroundColor: '#00000034',
      }}
    >
      <CardContent sx={{ p: 1 }}>
        <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
          {title}
        </Typography>
        <Box>
          <Line data={data} options={options} />
        </Box>
      </CardContent>
    </Card>
  )
}